import {SharedQuestion} from "./SharedQuestion";
import {PageSharedQuestion} from "./PageSharedQuestion";

export class PageDynamicSharedQuestion extends PageSharedQuestion {
    
}